import { tns } from 'tiny-slider/src/tiny-slider';

class MediaContentSlider {
	constructor(el) {
		this.el = el;

		const mediaContentSlider = tns({
			container: this.el,
			autoplay: true,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: false
		});

		return mediaContentSlider;
		
	}
}

export default MediaContentSlider;